import { render, staticRenderFns } from "./ContactProForm.vue?vue&type=template&id=c1b704fa"
import script from "./ContactProForm.vue?vue&type=script&lang=js"
export * from "./ContactProForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports